<mat-form-field appearance="fill" class="form-field-no-error">
  <mat-label>{{ 'performance.selectPeriodTitle' | translate }}</mat-label>
  <mat-select [ngModel]="queuer()" (ngModelChange)="changeQueuer.emit($event)">
    @for (option of queuerList(); track option) {
      <mat-option [value]="option">
        {{ 'performance.quarterSelect' | translate: { quarter: option.quarter, year: option.year } }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
